import { status } from "../constants/status"

export default function get_deployements_data() {
    return [
        {
            key: 1,
            title: 'Customer Support Chatbot',
            status: status.ab_testing,
            first_model_exposure: 30,
            first_model: {
                key: "ab_1",
                title: 'My Llama 3 8B',
                last_trained: '2024-04-11-11:35:03',
                base_model_name: 'Llama 3 8B',
                dataset_name: 'customer-support-q&a',
                dataset_entries: '137581',
                dataset_size: '10GB',
                thumbs_up: 6245,
                thumbs_down: 752,
                status: status.ab_testing,
                my_golden_data: 70,
                test_internal: 85.4,
            },
            second_model: {
                key: "ab_2",
                title: 'GPT-4o',
                last_trained: '2024-05-10-09:05:03',
                base_model_name: 'Mistral 7B',
                dataset_name: 'customer-support-q&a',
                dataset_entries: '137581',
                dataset_size: '10GB',
                thumbs_up: 321,
                thumbs_down: 2,
                status: status.ab_testing,
                my_golden_data: 69.8,
                test_internal: 89,
            },
        },
        {
            key: 2,
            title: 'Model3',
            last_trained: '2024-04-11-11:35:03',
            base_model_name: 'bart_base',
            dataset_name: 'customer-support-q&a',
            dataset_entries: '137581',
            dataset_size: '10GB',
            status: status.deployed_and_running,
            thumbs_up: 6245,
            thumbs_down: 320,
            my_golden_data: 70,
            test_internal: 85.4,
        },
        {
            key: 3,
            title: 'Model4',
            last_trained: '2024-04-14-11:35:03',
            base_model_name: 'bart_base',
            dataset_name: 'customer-support-q&a',
            dataset_entries: '137581',
            dataset_size: '10GB',
            status: status.deployed_and_running,
            thumbs_up: 10,
            thumbs_down: 10,
            my_golden_data: 70,
            test_internal: 85.4,
        },
        {
            key: 4,
            title: 'Model7',
            last_trained: '2023-02-06-08:27:12',
            base_model_name: 'bart_base',
            dataset_name: 'customer-support-q&a',
            dataset_entries: '3621',
            dataset_size: '5GB',
            status: status.serving_ready,
            thumbs_up: 12,
            thumbs_down: 13,
            my_golden_data: 70,
            test_internal: 85.4,
        },
        {
            key: 5,
            title: 'Model6',
            last_trained: '2023-03-12-10:35:03',
            base_model_name: 'bart_base',
            dataset_name: 'customer-support-q&a',
            dataset_entries: '3612504',
            dataset_size: '31GB',
            status: status.serving_ready,
            thumbs_up: 241,
            thumbs_down: 1520,
            my_golden_data: 70,
            test_internal: 85.4,
        },
        {
            key: 6,
            title: 'Model1',
            last_trained: '2024-05-13-10:40:03',
            base_model_name: 't5_base',
            dataset_name: 'customer-support-chatbot',
            dataset_entries: '183521',
            dataset_size: '12GB',
            status: status.serving_ready,
            thumbs_up: 0,
            thumbs_down: 0,
            my_golden_data: 70,
            test_internal: 85.4,
        },
        {
            key: 7,
            title: 'Model2',
            last_trained: '2024-04-12-11:35:03',
            base_model_name: 'bart_base',
            dataset_name: 'customer-support-q&a',
            dataset_entries: '137581',
            dataset_size: '10GB',
            status: status.serving_paused,
            thumbs_up: 3216,
            thumbs_down: 1432,
            my_golden_data: 70,
            test_internal: 85.4,
        },

        {
            key: 8,
            title: 'Model5',
            last_trained: '2024-05-01-11:35:03',
            base_model_name: 'bart_base',
            dataset_name: 'customer-support-q&a',
            dataset_entries: '362943',
            dataset_size: '22GB',
            status: status.serving_paused,
            thumbs_up: 8172,
            thumbs_down: 34,
            my_golden_data: 70,
            test_internal: 85.4,
        },
    ]
}